export default "__VITE_ASSET__64f5af5b__"